module.exports = __webpack_public_path__ + "static/Feature-01-4651a4c24e03be2a18accbf2fd5cf5b4.png";